// extracted by mini-css-extract-plugin
export default {"dialog":"DarTruHWWYucc6G6","body":"qYuhzuKgP08vIBcb","group":"yz0A8wjPEA0M4FE9"};